// extracted by mini-css-extract-plugin
export default {"container":"b1-z","heading":"c1-z","links":"d1-z","copy":"e1-z","subCopy":"f1-z","linksLeft":"g1-z","linksCenter":"h1-z","linksRight":"i1-z","link":"j1-z","onlyLink":"k1-z"};